import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "../../hooks";
import { TasksRoutes } from "./TasksRoutes";
import { Loader } from "../../components/Loader/Loader";
import { getTasks } from "../../redux/tasks/get-tasks.handler";
import { ErrorSnackbar } from "../../components/ErrorSnackbar/ErrorSnackbar";
import { tasksClearError } from "../../redux/tasks";

export const TasksPage = () => {
    const { loading, error } = useSelector(store => store.tasks);

    const dispatch = useDispatch();
    const errorRef = useRef(error);

    useEffect(() => {
        errorRef.current = error;
    }, [error]);

    useEffect(() => {
        if (errorRef.current)
            dispatch(tasksClearError());
    }, [dispatch]); // не добавлять error
    
    useEffect(() => {
        dispatch(getTasks());
    }, [dispatch]);
    
    return (
        <>
            <TasksRoutes />
            { loading && <Loader /> }
            { error.length > 0 && <ErrorSnackbar errorMessage={ error } /> }
        </>
    );
}